import { ScormEntry } from "./ScormEntry";

export class ScreenerResultDto {
    screenerId: number;
    objectId: string;
    entries: ScormEntry[];   
}